// this is the our app jwt key to authorize on the platform (same for all shops)
export const bigcommerceAppClientId = '487q5opptysx3xzdeznd9kdh515o2g7';
